// @ts-nocheck
import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';

interface ImageLightboxProps {
  images: string[];
  index: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

export default function ImageLightbox({ images, index, onClose, onPrev, onNext }: ImageLightboxProps) {
  useEffect(() => {
    const handle = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [onClose, onPrev, onNext]);

  if (!images.length) return null;
  const src = images[Math.max(0, Math.min(index, images.length - 1))];

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center">
      <div className="absolute top-4 right-4 flex gap-2">
        <Button variant="outline" className="border-white/30 text-white hover:bg-white/10" onClick={onClose}>Close</Button>
      </div>
      <div className="max-w-[90vw] max-h-[85vh] flex items-center justify-center p-4">
        <img src={src} alt="preview" className="max-w-full max-h-full rounded-xl border border-white/20 shadow-2xl" />
      </div>
      <button aria-label="Previous" className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-3xl" onClick={onPrev}>&lsaquo;</button>
      <button aria-label="Next" className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-3xl" onClick={onNext}>&rsaquo;</button>
    </div>
  );
}


